import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '../../lib/cn';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const inputId = id ?? props.name;
    return (
      <label className="flex w-full flex-col gap-2 text-left">
        {label ? (
          <span className="label-sm text-on-surface/70">{label}</span>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'w-full border-0 border-b-2 border-outline-variant/30 bg-surface-variant/20 px-4 py-3 text-on-surface outline-none transition-all focus:border-primary focus:bg-surface-variant/30',
            error && 'border-error text-error',
            className,
          )}
          {...props}
        />
        {error ? <span className="text-xs font-semibold text-error">{error}</span> : null}
      </label>
    );
  },
);

Input.displayName = 'Input';
